import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {EquipScheduleA} from '../domain/item';

@Injectable({
  providedIn: 'root'
})
export abstract class ItemSummaryScheduleNumberService {

  siteHoldingPenSchedulesCallback: Subject<EquipScheduleA[]> = new Subject<EquipScheduleA[]>();

  abstract getSchedulesForSiteHoldingPenAndContract(siteId: number, contractId: number): void;
}
